import { JanelaModal } from '../../participantes/ui/JanelaModal';
import type { ComandoDaTurma } from '../api/turma';

interface ConfirmacaoDeTurmaProps {
    comando: ComandoDaTurma;
    turmaId: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

const TEXTOS: Record<ComandoDaTurma, { verbo: string; corpo: string }> = {
    iniciar: {
        verbo: 'Iniciar',
        corpo: 'Registra o início da turma. Nenhuma fase é aberta: o jogo começa quando os facilitadores '
            + 'iniciam as estações, nos tablets.',
    },
    finalizar: {
        verbo: 'Finalizar',
        corpo: 'Encerra as fases e estações em andamento, desconecta os tablets e bloqueia novos logins. '
            + 'Os dados e as pontuações ficam preservados, e a turma pode ser reaberta depois.',
    },
    reabrir: {
        verbo: 'Reabrir',
        corpo: 'Libera de novo o login dos tablets. O estado da turma é preservado e nenhuma fase é aberta.',
    },
};

/** Confirmação de Iniciar, Finalizar e Reabrir Turma (`DP-RA-005`). */
export function ConfirmacaoDeTurma({ comando, turmaId, processando, aoCancelar, aoConfirmar }: ConfirmacaoDeTurmaProps) {
    const { verbo, corpo } = TEXTOS[comando];
    return (
        <JanelaModal titulo={`${verbo} a turma ${turmaId}?`} aoFechar={aoCancelar} bloqueada={processando}>
            <p>{corpo}</p>
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button
                    type="button"
                    className={`botao-confirmar ${comando === 'finalizar' ? 'botao-inativar' : 'botao-reativar'}`}
                    onClick={aoConfirmar}
                    disabled={processando}
                >
                    {processando ? 'Processando…' : `${verbo} Turma`}
                </button>
            </div>
        </JanelaModal>
    );
}
